<!-- 单元格一行，省略可滑看 -->
<template>
	<el-tooltip class="item" effect="dark" :content="item" placement="top-start">
	    <div class="omit1">{{item}}</div>
	</el-tooltip>
</template>

<script>
	export default{
		props:{
			item:{
				type:String,
				default:''
			}
		}
	}
</script>

<style scoped>
	.omit1{
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
	}
</style>